export const STORE_NAMES = Object.freeze({
    DEVICES_STORE: 'devices'
});

const readwrite = 'readwrite';
const readonly = 'readonly';

const LOCAL_DB = 'stdb';
const CURRENT_DB_VERSION = 2;

const FIELD_NAMES = Object.freeze({
    //TODO: Change from equipDetailsId to something universal.
    deviceId: "equipDetailsId",
    siteId: "siteId"
});

class DbClient {
    constructor() {
        const request = window.indexedDB.open(LOCAL_DB, CURRENT_DB_VERSION);
        request.onupgradeneeded = function (event) {
            let db = event.target.result;
            let transaction = event.target.transaction;
            let oldVersion = event.oldVersion;
            switch (oldVersion) {
                /*
                    Existing DB schema per version should not change once released in prod. Users would have to delete
                    existing DB from device.
                 */
                case 0:
                    db.createObjectStore(STORE_NAMES.DEVICES_STORE, {keyPath: FIELD_NAMES.deviceId});
                // fall through
                case 1:
                    transaction
                        .objectStore(STORE_NAMES.DEVICES_STORE)
                        .createIndex(FIELD_NAMES.siteId, FIELD_NAMES.siteId, {unique: false});
                // fall through
                default:
                // none
            }
        };
        this.dbPromise = new Promise((resolve, reject) => {
            request.onsuccess = function () {
                resolve(request.result);
            };
            request.onerror = function () {
                reject(request.error);
            };
        });
    }

    checkDbConnection = (errorHandle) => {
        this.dbPromise.catch(errorHandle);
    };

    closeDbConnection = () => {
        this.dbPromise.then(db => {
            console.log('closing db');
            db.close();
        });
    };

    putDevice = (device) => {
        this.dbPromise
            .then(db => {
                const transaction = db.transaction([STORE_NAMES.DEVICES_STORE], readwrite);
                const obStore = transaction.objectStore(STORE_NAMES.DEVICES_STORE);
                let old = obStore.get(device.equipDetailsId);
                old.onsuccess = function (event) {
                    transaction.objectStore(STORE_NAMES.DEVICES_STORE).put({...event.target.result, ...device});
                };
            })
            .catch(error => {
                console.log('putDevice error', error);
            });
    };

    deleteDevice = (id) => {
        this.dbPromise
            .then(db => {
                const transaction = db.transaction([STORE_NAMES.DEVICES_STORE], readwrite);
                const obStore = transaction.objectStore(STORE_NAMES.DEVICES_STORE);
                obStore.delete(id);
            })
            .catch(error => {
                console.log('deleteDevice error', error);
            });
    };

    getAllDevices = (siteId, devicesCallback) => {
        this.dbPromise
            .then(db => {
                const transaction = db.transaction([STORE_NAMES.DEVICES_STORE], readonly);
                const devicesStore = transaction.objectStore(STORE_NAMES.DEVICES_STORE);
                const index = devicesStore.index(FIELD_NAMES.siteId);
                const devices = [];
                index.openCursor(IDBKeyRange.only(siteId)).onsuccess = function (event) {
                    const cursor = event.target.result;
                    if (cursor) {
                        devices.push(cursor.value);
                        cursor.continue();
                    } else {
                        devicesCallback({devices});
                    }
                };
            });
    };
}

export default DbClient;


// WEBPACK FOOTER //
// ./src/state/persistence/dbClient.js